import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import BackspaceIcon from '@material-ui/icons/Backspace';
import SearchIcon from '@material-ui/icons/Search';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import OutlinedInput from '@material-ui/core/OutlinedInput';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      padding: theme.spacing(0),
      display: 'flex',
      alignItems: 'center',
      width: 400,
    },
    rootBorder: {
      border: `1px solid ${ theme.palette.alternate.main }`,
    },
    rootBorderFocused: {
      border: `1px solid ${ theme.palette.alternate.dark }`,
    },
    rootBorderActive: {
      border: `1px solid ${ theme.palette.secondary.main }`,
    },
    input: {
      marginLeft: theme.spacing(1),
      flex: 1,
    },
    iconButton: {
      padding: 10,
    },
    divider: {
      backgroundColor: theme.palette.alternate.main,
      height: 28,
      margin: 4,
    },
  };
});

export default function SearchBar(props) {
  const classes = useStyles();

  return (
    <Grid container style={ { maxWidth: 400 } }>
      <FormControl style={ { width: '100%' } }>
        <OutlinedInput
          id='standard-search-bar'
          color='secondary'
          type='text'
          value={ props.value }
          placeholder={ props.placeholder || 'Search ...' }
          onChange={ (e) => { return props.onChange(e.target.value); } }
          startAdornment={ (
            <InputAdornment position='start'>
              <IconButton disabled className={ classes.iconButton } aria-label='search'>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          ) }
          endAdornment={ (
            <InputAdornment position='end'>
              <Divider className={ classes.divider } orientation='vertical' />
              <IconButton
                onClick={ () => { return props.onChange(''); } }
                disabled={ !props.value }
                className={ classes.iconButton }
                aria-label='directions'
              >
                <BackspaceIcon />
              </IconButton>
            </InputAdornment>
          ) }
        />
      </FormControl>
    </Grid>
  );
}
